import { render, staticRenderFns } from "./NewsListView.vue?vue&type=template&id=01ea1530&scoped=true&"
import script from "./NewsListView.vue?vue&type=script&lang=js&"
export * from "./NewsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea1530",
  null
  
)

export default component.exports